<template>
	<section class="section" :class="{'full-size-help': activeHelpInfo}">
		<div class="columns" v-if="activeHelpInfo">
			<div class="column full-size-column">
				<div class="box box-green has-text-left">
					<div class="columns">
						<div class="column">
							<span class="icon is-clickable is-large has-text-info is-pulled-right" @click="activeHelpInfo = false">
								<span class="fa-stack fa-lg has-text-centered">
									<i class="fas fa-circle fa-2x"></i>
									<i class="fas fa-info fa-stack-1x fa-inverse"></i>
								</span>
							</span>
							<h2 class="title has-text-white is-baskerville">{{ $t('Ohjeita hautakiven suunnitteluun') }}</h2>
							<p class="has-text-white has-text-weight-bold is-baskerville">{{ $t('Hautakivi suunnitellaan neljässä vaiheessa. Aloita valitsemalla kivimalli, seuraa ohjeita ja lisää tarvittavat tiedot. Jaa lopuksi suunnitelma läheistesi kanssa ja tee tilaus.') }}</p>
						</div>
					</div>
					<div class="columns">
						<div class="column">
							<h2 class="subtitle has-text-weight-bold has-text-white is-baskerville">{{ $t('1. Hautakiven suunnittelu') }}</h2>
							<p class="has-text-white is-baskerville">{{ $t('Ensimmäisessä vaiheessa voit valita valmiin design-kiven tai täysin muokattavan mallin. Valmiissa mallissa koko, kivilaji ja sivujen käsittely on suunniteltu valmiiksi. Muokattavassa mallissa voit valita ne itse. Lisäksi voit määrittää tuleeko tilaukseen mukaan pohjakivi. Esikatselukuva ja hinta päivittyy sitä mukaa, kun teet valintoja.') }}</p>
							<p class="has-text-white is-baskerville">{{ $t('Kun olet täyttänyt kaikki tarvittavat kentät, pääset eteenpäin seuraava- painiketta klikkaamalla. Info-painikkeista saat lisätietoa kyseisestä kohdasta.') }}</p>
							<h2 class="subtitle has-text-weight-bold has-text-white is-baskerville">{{ $t('2. Tekstit ja koristeet') }}</h2>
							<p class="has-text-white is-baskerville">{{ $t('Toisessa vaiheessa voit tyylitellä tekstien ja koristeiden ulkoasua, mikäli et ole valinnut designkiveä, jossa valinnat on määritetty. Esikatselukuvassa näkyy esimerkkiteksti, kunnes vainajan tiedot on syötetty seuraavassa vaiheessa. Mikäli et löydä mieluista vaihtoehtoa tai haluat lisätä muita koristeita, voit olla yhteydessä asiakaspalvelijaamme.') }}</p>
						</div>
						<div class="column">
							<h2 class="subtitle has-text-weight-bold has-text-white is-baskerville">{{ $t('3. Vainajan tiedot') }}</h2>
							<p class="has-text-white is-baskerville">{{ $t('Kolmannessa vaiheessa täytetään vainajan tiedot. Esikatselukuva ja hinta päivittyvät sitä mukaa, kun täytät tietoja. Joidenkin mallien hinta riippuu sukunimen pituudesta, joten lopullinen hinta näkyy vasta nimen syöttämisen jälkeen. Edellinen-painikkeesta pääset takaisin aiempiin vaiheisiin.') }}</p>
							<p class="has-text-white is-baskerville">{{ $t('Jos vainajan henkilötiedot ovat pitkät tai asemointi poikkeaa standardeista, asiakaspalvelijamme ottaa sinuun yhteyttä tilauksen tekemisen jälkeen asemoinnin tarkastamiseksi. Mikäli haluat lisätä kiveen useammat tiedot, voi laittaa siitä tiedon tilauslomakkeen lopussa olevaan lisätietoja-kohtaan.') }}</p>
							<h2 class="subtitle has-text-weight-bold has-text-white is-baskerville">{{ $t('4. Tilaajan tiedot') }}</h2>
							<p class="has-text-white is-baskerville">{{ $t('Viimeisessä vaiheessa syötetään tilaajan tiedot, hautapaikkatiedot, lisätiedot ja mahdollinen alennuskoodi. Ennen tilauksen lähettämistä voit tallentaa suunnitelmasi ja lähettää sen omaan ja läheistesi sähköpostiin. Sähköpostiin tulevasta linkistä pääset myöhemmin jatkamaan suunnitelman tekoa siitä mihin jäit.') }}</p>
							<p class="has-text-white is-baskerville">{{ $t('Kun olet lähettänyt tilauksen onnistuneesti, tarkastamme suunnitelman ja lähetämme tilausvahvistuksen. Mikäli tilauksessa on jotain epäselvää, asiakaspalvelijamme ottaa sinuun yhteyttä heti tilauksen tultua käsittelyyn.') }}</p>
							<p class="has-text-white is-baskerville">{{ $t('Autamme sinua mielellämme kaikissa tilaukseen liittyvissä asioissa. Voit olla yhteydessä sähköpostitse asiakaspalvelu@joutsenkivi.fi, puhelimitse 050 435 4422 tai yhteydenottolomakkeella.') }}</p>
						</div>
					</div>
					<div class="columns">
						<div class="column is-2 is-offset-5">
							<button class="button is-white has-text-info is-fullwidth" @click="activeHelpInfo = false">{{ $t('OK') }}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="has-text-centered">
			<div class="columns border-bottom-info">
				<div class="column">
					<h1 id="conf-title" class="title has-text-info has-text-weight-bold">{{ $t('Suunnittele hautakivi') }}</h1>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="columns is-mobile pageSelector">
						<div class="column is-3 is-3-mobile pageMove" v-if="page > 1 && page < 5" @click="prevPage()">
							<span class="icon has-text-info is-pulled-left">
								<i class="fas fa-3x fa-angle-left" aria-hidden="true"></i>
							</span>
							<span class="is-hidden-mobile has-text-info has-text-weight-bold is-pulled-right">{{ $t('Edellinen') }}</span>
						</div>
						<div class="column is-6 is-6-mobile" :class="{'is-offset-3 is-offset-3-mobile': page <= 1 || page >= 5}">
							<h2 class="subtitle is-size-5 has-text-white has-text-weight-bold" v-if="page < 5">{{ page }} / 4</h2>
							<h2 class="subtitle is-size-5 has-text-white has-text-weight-bold" v-else>{{ $t('Valmis') }}</h2>
						</div>
						<div class="column is-3 is-3-mobile pageMove" v-if="page < 4 && showNext()" @click="nextPage()">
							<span class="is-hidden-mobile has-text-info has-text-weight-bold is-pulled-left">{{ $t('Seuraava') }}</span>
							<span class="icon has-text-info is-pulled-right">
								<i class="fas fa-3x fa-angle-right" aria-hidden="true"></i>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<h2 class="title has-text-info has-text-weight-bold is-baskerville">{{ $t(pageHeaders[page-1]) }}</h2>
				</div>
			</div>
			<div class="columns reverse-row-order" v-if="page == 1">
				<div class="column">
					<div id="select-model" class="field">
						<label class="label has-text-left has-text-info">{{ $t('Valitse malli') }}</label>
						<div class="control">
							<div class="dropdown" :class="{ 'is-active': activeDropdown === 'model' }">
								<div class="dropdown-trigger" @click="activeDropdown === 'model' ? activeDropdown = '' : activeDropdown = 'model'">
									<button class="button has-text-info" aria-haspopup="true" aria-controls="dropdown-menu-model">
										<span class="has-text-weight-bold">{{ model !== '' ? models[model].name : '' }}</span>
										<span class="icon is-small">
											<i class="fas fa-angle-down" aria-hidden="true"></i>
										</span>
									</button>
								</div>
								<div class="dropdown-menu" id="dropdown-menu-model" role="menu">
									<div class="dropdown-content">
										<template v-for="(m, key) in models">
											<div class="dropdown-item" :key="key+'-item'">
												<div class="columns">
													<div class="column">
														<h2 class="subtitle has-text-info has-text-weight-bold is-baskerville">{{ m.name }}</h2>
														<p class="has-text-info"><b>{{ $t('Kivilaji') }}:</b> {{ m.stone.desc }}</p>
														<p class="has-text-info"><b>{{ $t('Tekstit ja koristeet') }}:</b> {{ m.color.desc }}</p>
														<p class="has-text-info"><b>{{ $t('Fontit') }}:</b> {{ m.font.desc }}</p>
														<p class="has-text-info"><b>{{ $t('Koristeet') }}:</b> {{ m.decoration.desc }}</p>
                    									<p class="has-text-info" v-if="m.decoration2"><b>{{ $t('Koristeet') }}:</b> {{ m.decoration2.desc }}</p>
														<p class="has-text-info"><b>{{ $t('Koot') }}:</b> {{ m.size.desc }}</p>
														<p class="has-text-info" v-if="m.side.desc"><b>{{ $t('Hautakiven sivut') }}:</b> {{ m.side.desc }}</p>
														<p class="has-text-info"><b>{{ $t('Perushinta') }}:</b> {{ m.size.options.map(function(o){ return o.price; }).join(" / ") }} €</p>
														<p class="has-text-info" v-if="m.design_stone === true">{{ $t('design_stone_help') }}</p>
														<button class="button is-info" @click="setModel(key)">{{ $t('Valitse') }}</button>
													</div>
													<div class="column" v-if="m.img">
														<div class="columns is-flex is-vcentered is-centered">
															<img :src="imgUrl(m.img)">
														</div>
													</div>
												</div>
											</div>
											<hr :key="key+'-divider'" v-if="key+1 != models.length" class="dropdown-divider">
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<label class="label has-text-left has-text-info">{{ $t('Valitse koko') }}</label>
						<div class="control">
							<div class="dropdown" :class="{ 'is-active': activeDropdown === 'size' }">
								<div class="dropdown-trigger" @click="activeDropdown === 'size' ? activeDropdown = '' : activeDropdown = 'size'">
									<button class="button has-text-info" aria-haspopup="true" aria-controls="dropdown-menu-model2">
										<span class="has-text-weight-bold">{{ size !== '' ? models[model].size.options[size].name : '' }}</span>
										<span class="icon is-small">
											<i class="fas fa-angle-down" aria-hidden="true"></i>
										</span>
									</button>
								</div>
								<div class="dropdown-menu" id="dropdown-menu-model2" role="menu" v-if="model !== ''">
									<div class="dropdown-content">
										<template v-for="(s, key) in models[model].size.options">
											<div class="dropdown-item" :key="key+'-item'">
												<button class="button is-info" :class="s.class" @click="size = key, activeDropdown = '', decoration = 0, setNameSizes()">{{ s.name }}</button>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<label class="label has-text-left has-text-info">{{ $t('Kivilaji') }}</label>
						<div class="control">
							<div class="dropdown" :class="{ 'is-active': activeDropdown === 'stone' }">
								<div class="dropdown-trigger" @click="activeDropdown === 'stone' ? activeDropdown = '' : activeDropdown = 'stone'">
									<button class="button has-text-info" aria-haspopup="true" aria-controls="dropdown-menu-model3">
										<span class="has-text-weight-bold">{{ stone !== '' ? models[model].stone.options[stone].name : '' }}</span>
										<span class="icon is-small">
											<i class="fas fa-angle-down" aria-hidden="true"></i>
										</span>
									</button>
								</div>
								<div class="dropdown-menu" id="dropdown-menu-stone" role="menu" v-if="model !== ''">
									<div class="dropdown-content">
										<template v-for="(v, key) in models[model].stone.options">
											<div class="dropdown-item" :key="key+'-item'">
												<button class="button is-info stone-swatch" :class="[v.option || v.class, {'is-selected': stone === key}]" @click="stone = key, activeDropdown = '', setNameSizes()"><span>{{ v.name }}</span></button>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field" v-if="model !== '' && models[model].side.options.length">
						<label class="label has-text-left has-text-info">
							{{ $t('Hautakiven sivujen käsittely') }}
							<span class="icon is-clickable is-pulled-right has-text-info" @click="activeSideInfo = !activeSideInfo">
								<i class="fas fa-info-circle"></i>
							</span>
						</label>
						<div v-if="activeSideInfo" class="box box-green has-text-left">
							<span class="icon is-clickable has-text-white is-pulled-right" @click="activeSideInfo = false">
								<i class="fas fa-times"></i>
							</span>
							<p class="has-text-white">{{ $t('Hautakiven reunojen kiillottaminen tekee hautakivestä helppohoitoisemman ja arvokkaamman näköisen.') }}</p>
						</div>
						<div v-else class="control">
							<div class="dropdown" :class="{ 'is-active': activeDropdown === 'side' }">
								<div class="dropdown-trigger" @click="activeDropdown === 'side' ? activeDropdown = '' : activeDropdown = 'side'">
									<button class="button has-text-info" aria-haspopup="true" aria-controls="dropdown-menu-model3">
										<span class="has-text-weight-bold">{{ side !== '' ? models[model].side.options[side].name : '' }}</span>
										<span class="icon is-small">
											<i class="fas fa-angle-down" aria-hidden="true"></i>
										</span>
									</button>
								</div>
								<div class="dropdown-menu" id="dropdown-menu-model3" role="menu">
									<div class="dropdown-content">
										<template v-for="(s, key) in models[model].side.options">
											<div class="dropdown-item" :key="key+'-item'">
												<button class="button is-info" @click="side = key, activeDropdown = '', setNameSizes()">{{ s.name }}</button>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--
					<div class="field" v-if="model !== '' && models[model].bottom.options.length">
						<label class="label has-text-left has-text-info">
							{{ $t('Pohjakivi') }}
							<span class="icon is-clickable is-pulled-right has-text-info" @click="activeBottomInfo = !activeBottomInfo">
								<i class="fas fa-info-circle"></i>
							</span>
						</label>
						<div v-if="activeBottomInfo" class="box box-green has-text-left">
							<span class="icon is-clickable has-text-white is-pulled-right" @click="activeBottomInfo = false">
								<i class="fas fa-times"></i>
							</span>
							<p class="has-text-white">{{ $t('Pohjakivi tarvitaan, mikäli hautapaikalla ei ole seurakunnan tarjoamaa pohjakiveä tai palkkia. Tarkemmat tiedot hautapaikasta saat hautakirjasta tai tiedustelemalla seurakunnalta.') }}</p>
						</div>
						<div v-else class="control">
							<div class="dropdown" :class="{ 'is-active': activeDropdown === 'bottom' }">
								<div class="dropdown-trigger" @click="activeDropdown === 'bottom' ? activeDropdown = '' : activeDropdown = 'bottom'">
									<button class="button has-text-info" aria-haspopup="true" aria-controls="dropdown-menu-model4">
										<span class="has-text-weight-bold">{{ bottom !== '' ? models[model].bottom.options[bottom].name : '' }}</span>
										<span class="icon is-small">
											<i class="fas fa-angle-down" aria-hidden="true"></i>
										</span>
									</button>
								</div>
								<div class="dropdown-menu" id="dropdown-menu-model4" role="menu">
									<div class="dropdown-content">
										<template v-for="(b, key) in models[model].bottom.options">
											<div class="dropdown-item" :key="key+'-item'">
												<button class="button is-info" @click="bottom = key, activeDropdown = '', setNameSizes()">{{ b.name }}</button>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
				-->
				</div>

				<div class="column" v-if="model === ''">
					<div class="columns is-flex is-vcentered is-centered">
						<div class="column">
							<span class="icon is-clickable is-large has-text-info help-info" @click="activeHelpInfo = !activeHelpInfo">
								<span class="fa-stack fa-lg has-text-centered">
									<i class="fas fa-circle fa-2x"></i>
									<i class="fas fa-info fa-stack-1x fa-inverse"></i>
								</span>
							</span>
							<h2 class="subtitle is-italic has-text-weight-bold has-text-info is-baskerville">{{ $t('Aloita valitsemalla kivimalli, seuraa ohjeita ja lisää tarvittavat tiedot. Jaa lopuksi suunnitelma läheistesi kanssa ja tee tilaus.') }}</h2>
						</div>
					</div>
				</div>
			</div>

			<div class="columns" v-if="page == 1 && !activeHelpInfo && model !== '' && size !== '' && stone !== '' && bottom !== ''">
				<design-details :model="model" :stone="stone" :color="color" :font="font" :decoration="decoration" :decoration2="decoration2" :size="size" :side="side" :bottom="bottom" :firstnames="firstnames" :lastname="lastname" :dob="dob" :dod="dod" v-on:goToModelSelection="goToModel()" :hasTextLeftTablet="false" :price="calcPrice()"></design-details>
			</div>

			<div class="columns reverse-row-order" v-else-if="page == 2">
				<div class="column">
					<div class="field">
						<label class="label has-text-left has-text-info">{{ $t('Tekstin kirjasinlaji') }}</label>
						<div class="control">
							<div class="select">
								<select v-model="font">
									<option v-for="(f, key) in models[model].font.options" :key="key" :value="key">{{ f.name }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="field">
						<label class="label has-text-left has-text-info">{{ $t('Koristeet') }}</label>
						<div class="control">
							<div class="select">
								<select v-model="decoration">
									<option v-for="(d, key) in models[model].decoration.options.map(function(deco, index) { deco.realIndex = index; return deco; }).filter(function(deco){ return !deco.available_on_size ? true : (deco.available_on_size.includes(size) ? true : false); })" :key="key" :value="d.realIndex">{{ d.name }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="field" v-if="models[model].decoration2">
						<label class="label has-text-left has-text-info">{{ $t('Muut koristeet') }}</label>
						<div class="control">
							<div class="select">
								<select v-model="decoration2">
									<option v-for="(d2, key) in models[model].decoration2.options" :key="key" :value="key">{{ d2.name }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="field">
						<label class="label has-text-left has-text-info">{{ $t('Tekstin ja koristeiden sävy') }}</label>
						<div class="control">
							<div class="select">
								<select v-model="color">
									<option v-for="(c, key) in models[model].color.options" :key="key" :value="key">{{ c.name }}</option>
								</select>
							</div>
						</div>
					</div>
				</div>
				<design-details :model="model" :stone="stone" :color="color" :font="font" :decoration="decoration" :decoration2="decoration2" :size="size" :side="side" :bottom="bottom" :firstnames="firstnames" :lastname="lastname" :dob="dob" :dod="dod" v-on:goToModelSelection="goToModel()" :hasTextLeftTablet="true" :price="calcPrice()"></design-details>
			</div>

			<div class="columns reverse-row-order" v-else-if="page == 3">
				<div class="column">
					<div class="field">
						<label class="label has-text-left has-text-info">
							{{ $t('Sukunimi') }}
							<span class="icon is-clickable is-pulled-right has-text-info" @click="activeLastnameInfo = !activeLastnameInfo">
								<i class="fas fa-info-circle"></i>
							</span>
						</label>
						<div v-if="activeLastnameInfo" class="box box-green has-text-left">
							<span class="icon is-clickable has-text-white is-pulled-right" @click="activeLastnameInfo = false">
								<i class="fas fa-times"></i>
							</span>
							<p class="has-text-white">{{ $t('Jos vainajan henkilötiedot ovat pitkät tai asemointi poikkeaa standardeista, asiakaspalvelijamme ottaa sinuun yhteyttä tilauksen tekemisen jälkeen asemoinnin tarkastamiseksi.') }}</p>
							<p class="has-text-white">{{ $t('Mikäli haluat lisätä kiveen useammat tiedot, voi laittaa siitä tiedon tilauslomakkeen lopussa olevaan lisätietoja-kohtaan.') }}</p>
						</div>
						<div v-else class="control">
							<input class="input" v-model="lastname" type="text">
						</div>
					</div>
					<div class="field">
						<label class="label has-text-left has-text-info">{{ $t('Etunimet') }}</label>
						<div class="control">
							<input class="input" v-model="firstnames" type="text">
						</div>
					</div>
					<div class="field">
						<label class="label has-text-left has-text-info">{{ $t('Syntymäaika') }}</label>
						<div class="control has-icons-right">
							<input class="input" type="text" v-model="dob">
						</div>
					</div>
					<div class="field">
						<label class="label has-text-left has-text-info">{{ $t('Kuolinaika') }}</label>
						<div class="control has-icons-right">
							<input class="input" type="text" v-model="dod">
						</div>
					</div>
				</div>
				<design-details :model="model" :stone="stone" :color="color" :font="font" :decoration="decoration" :decoration2="decoration2" :size="size" :side="side" :bottom="bottom" :firstnames="firstnames" :lastname="lastname" :dob="dob" :dod="dod" v-on:goToModelSelection="goToModel()" :hasTextLeftTablet="true" :price="calcPrice()"></design-details>
			</div>

			<div class="columns" v-else-if="page == 4">
				<div class="column">
					<div class="columns reverse-row-order">
						<div class="column">
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Nimi') }}</label>
								<div class="control">
									<input class="input" v-model="name" type="text">
								</div>
							</div>
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Katuosoite') }}</label>
								<div class="control">
									<input class="input" v-model="address" type="text">
								</div>
							</div>
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Postinumero') }}</label>
								<div class="control">
									<input class="input" v-model="zip" type="text">
								</div>
							</div>
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Paikkakunta') }}</label>
								<div class="control">
									<input class="input" v-model="city" type="text">
								</div>
							</div>
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Puhelinnumero') }}</label>
								<div class="control">
									<input class="input" v-model="phone" type="text">
								</div>
							</div>
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Sähköposti') }}</label>
								<div class="control">
									<input id="email" class="input" :class="{ 'is-danger': emailError }" v-model="email" type="text">
								</div>
							</div>
						</div>
						<design-details class="is-hidden-mobile" :model="model" :stone="stone" :color="color" :font="font" :decoration="decoration" :decoration2="decoration2" :size="size" :side="side" :bottom="bottom" :firstnames="firstnames" :lastname="lastname" :dob="dob" :dod="dod" v-on:goToModelSelection="goToModel()" :hasTextLeftTablet="true" :priceHidden="true" :price="calcPrice()"></design-details>
					</div>
					<div class="columns reverse-row-order">
						<div class="column">
							<h2 class="subtitle has-text-info has-text-weight-bold">{{ $t('Hautapaikkatiedot') }}</h2>
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Seurakunta') }}</label>
								<div class="control">
									<input class="input" v-model="church" type="text">
								</div>
							</div>
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Hautausmaa') }}</label>
								<div class="control">
									<input class="input" v-model="graveyard" type="text">
								</div>
							</div>
							<div class="field">
								<label class="label has-text-left has-text-info">{{ $t('Hautapaikkatunnus') }}</label>
								<div class="control">
									<input class="input" v-model="graveId" type="text">
								</div>
							</div>
						</div>
						<div class="column">
							<h2 class="subtitle has-text-info has-text-weight-bold">{{ $t('Lisätietoja') }}</h2>
							<div class="field">
								<label class="label has-text-left has-text-info">
									{{ $t('Nimiä tulossa yhteensä') }}
									<span class="icon is-clickable is-pulled-right has-text-info" @click="activeNamesTotalInfo = !activeNamesTotalInfo">
										<i class="fas fa-info-circle"></i>
									</span>
								</label>
								<div v-if="activeNamesTotalInfo" class="box box-green has-text-left">
									<span class="icon is-clickable has-text-white is-pulled-right" @click="activeNamesTotalInfo = false">
										<i class="fas fa-times"></i>
									</span>
									<p class="has-text-white">{{ $t('Se, kuinka monelle tiedolle kiveen on tarkoitus varata tilaa tulevaisuudessa voi vaikuttaa nykyisen tiedon asemointiin. Mikäli asemointi poikkeaisi normaalista, olemme vielä yhteydessä asemoinnista tilauksen teon jälkeen.') }}</p>
								</div>
								<div v-else class="control">
									<input class="input" v-model="namesTotal" type="text">
								</div>
							</div>
							<div class="field">
								<label class="label has-text-left has-text-info">
									{{ $t('Muuta') }}
									<span class="icon is-clickable is-pulled-right has-text-info" @click="activeOtherInfo = !activeOtherInfo">
										<i class="fas fa-info-circle"></i>
									</span>
								</label>
								<div v-if="activeOtherInfo" class="box box-green has-text-left">
									<span class="icon is-clickable has-text-white is-pulled-right" @click="activeOtherInfo = false">
										<i class="fas fa-times"></i>
									</span>
									<p class="has-text-white">{{ $t('Tähän voit kirjoittaa mm. mikäli haluataan lisätä omaa sukua-tiedot taikka toisen nimitiedot samassa yhteydessä. Asiakaspalvelijamme on teihin yhteydessä, mikäli tilauksessanne on vielä jotain tarkennettavaa.') }}</p>
								</div>
								<div v-else class="control">
									<input class="input" v-model="other" type="text">
								</div>
							</div>
							<div class="field is-hidden-mobile">
								<label class="label has-text-left has-text-info">
									{{ $t('Alennuskoodi') }}
									<span class="icon is-clickable is-pulled-right has-text-info" @click="activeCodeInfo = !activeCodeInfo">
										<i class="fas fa-info-circle"></i>
									</span>
								</label>
								<div v-if="activeCodeInfo" class="box box-green has-text-left">
									<span class="icon is-clickable has-text-white is-pulled-right" @click="activeCodeInfo = false">
										<i class="fas fa-times"></i>
									</span>
									<p class="has-text-white">{{ $t('Mikäli sinulla on käytössäsi kampanja- tai alennuskoodi, syötä se tähän.') }}</p>
								</div>
								<div v-else class="control">
									<input class="input" v-model="code" type="text">
								</div>
							</div>
						</div>
					</div>
					<div class="columns">
						<design-details class="is-hidden-tablet" :model="model" :stone="stone" :color="color" :font="font" :decoration="decoration" :decoration2="decoration2" :size="size" :side="side" :bottom="bottom" :firstnames="firstnames" :lastname="lastname" :dob="dob" :dod="dod" v-on:goToModelSelection="goToModel()" :hasTextLeftTablet="true" :priceHidden="true" :price="calcPrice()"></design-details>
						<div class="column is-hidden-tablet">
							<div class="field">
								<label class="label has-text-left has-text-info">
									{{ $t('Alennuskoodi') }}
									<span class="icon is-clickable is-pulled-right has-text-info" @click="activeCodeInfo = !activeCodeInfo">
										<i class="fas fa-info-circle"></i>
									</span>
								</label>
								<div v-if="activeCodeInfo" class="box box-green has-text-left">
									<span class="icon is-clickable has-text-white is-pulled-right" @click="activeCodeInfo = false">
										<i class="fas fa-times"></i>
									</span>
									<p class="has-text-white">{{ $t('Mikäli sinulla on käytössäsi kampanja- tai alennuskoodi, syötä se tähän.') }}</p>
								</div>
								<div v-else class="control">
									<input class="input" v-model="code" type="text">
								</div>
							</div>
						</div>
						<div class="column has-text-left-tablet">
							<p class="is-size-2 has-text-info has-text-weight-bold">{{ calcPrice() }} €</p>
							<p class="is-size-7 has-text-info">{{ $t('Sis. ALV 24 % | Asennus + 90 €')}}</p>
						</div>
						<div class="column">
							<div class="buttons is-centered-mobile">
								<button class="button is-large is-rounded" :class="{'is-light': saveDisabled(),'is-success': !saveDisabled()}" @click="order()">{{ $t('Tilaa') }}</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="columns page-5" v-else-if="page == 5">
				<div class="column">
					<div class="columns is-centered">
						<span class="icon is-large has-text-success">
							<span class="fa-stack fa-lg has-text-centered">
								<i class="fas fa-circle fa-2x"></i>
								<i class="fas fa-check fa-stack-1x fa-inverse"></i>
							</span>
						</span>
					</div>
					<div class="columns is-centered">
						<h2 class="subtitle is-italic has-text-weight-bold has-text-info is-baskerville">{{ $t('Kiitos tilauksestanne! Käsittelemme tilauksenne parin arkipäivän kuluessa ja lähetämme tilausvahvistuksen sähköpostiinne.') }}</h2>
					</div>
				</div>
			</div>

			<div class="columns border-top-info">
				<div class="column">
					<div class="columns reverse-row-order">
						<div class="column is-half has-text-left" v-if="page == 4">
							<div class="field">
								<div class="field-label">
									<label class="label has-text-left has-text-info">
										{{ $t('Lähetä suunnitelma sähköpostiin') }}
										<span class="icon is-clickable is-pulled-right has-text-info" @click="activeSendEmailInfo = !activeSendEmailInfo">
											<i class="fas fa-info-circle"></i>
										</span>
									</label>
								</div>
								<div v-if="activeSendEmailInfo" class="box box-green has-text-left">
									<span class="icon is-clickable has-text-white is-pulled-right" @click="activeSendEmailInfo = false">
										<i class="fas fa-times"></i>
									</span>
									<p class="has-text-white">{{ $t('Tallenna ja jaa suunnitelma omaasi ja läheistesi sähköpostiin. Sähköpostiin tulevasta linkistä pääset jatkamaan suunnittelua siitä mihin vaiheeseen jäit.') }}</p>
								</div>
								<div v-else class="field-body">
									<div class="field has-addons">
										<div class="control is-expanded">
											<input class="input" :class="{ 'is-danger': sendEmailError }" v-model="sendEmail" type="text" :placeholder="$t('Lisää vastaanottajan sähköposti(t)')">
										</div>
										<div class="control">
											<a class="button" @click="addEmail()">
												<span class="icon is-small has-text-info">
													<i class="fas fa-plus"></i>
												</span>
											</a>
										</div>
									</div>
								</div>
							</div>
							<div class="field is-grouped is-grouped-multiline">
								<p class="control" v-for="(e, key) in sendToEmails" :key="key">
									<a class="button" @click="removeEmail(key)">
										{{ e }}
									</a>
								</p>
							</div>
							<button class="button" :class="{'is-light': !sendToEmails.length, 'is-success': sendToEmails.length}" @click="sendEmails()">{{ $t('Tallenna ja jaa') }}</button>
						</div>
						<div class="column">
							<p class="is-size-7-touch has-text-info">{{ $t('Autamme sinua mielellämme kaikissa tilaukseen liittyvissä asioissa. Voit olla yhteydessä sähköpostitse asiakaspalvelu@joutsenkivi.fi, puhelimitse 050 435 4422 tai yhteydenottolomakkeella. Mikäli tilauksessa on jotain epäselvää, asiakaspalvelijamme ottaa sinuun yhteyttä heti tilauksen tultua käsittelyyn.') }}</p>
						</div>
						<div class="column is-1 is-hidden-mobile">
							<div class="columns is-flex is-vcentered is-centered">
								<span class="icon is-clickable is-large has-text-info" @click="openHelp()">
									<span class="fa-stack fa-lg has-text-centered">
										<i class="fas fa-circle fa-2x"></i>
										<i class="fas fa-info fa-stack-1x fa-inverse"></i>
									</span>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="columns is-hidden-desktop border-top-mobile-footer" v-if="page < 5">
				<div class="column">
					<div class="columns is-mobile">
						<div class="column is-pulled-left">
							<div class="is-pulled-left is-size-6 pageMove" v-if="page > 1" @click="prevPage()">
								<span class="icon has-text-info is-pulled-left">
									<i class="fas fa-2x fa-angle-left" aria-hidden="true"></i>
								</span>
								<span class="has-text-info has-text-weight-bold is-pulled-right">{{ $t('Edellinen') }}</span>
							</div>
						</div>
						<div class="column is-pulled-right">
							<div class="is-pulled-right is-size-6 pageMove" v-if="page < 4 && showNext()" @click="nextPage()">
								<span class="has-text-info has-text-weight-bold is-pulled-left">{{ $t('Seuraava') }}</span>
								<span class="icon has-text-info is-pulled-right">
									<i class="fas fa-2x fa-angle-right" aria-hidden="true"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="columns border-top-mobile-footer" v-else-if="page == 5">
				<div class="column">
					<div class="columns is-mobile">
						<div class="column is-pulled-left">
							<div class="is-pulled-left is-size-6" @click="restart()">
								<span class="icon has-text-info is-pulled-left">
									<i class="fas fa-2x fa-angle-left" aria-hidden="true"></i>
								</span>
								<span class="has-text-info has-text-weight-bold is-pulled-right">{{ $t('Takaisin etusivulle') }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import models from '../models.json';
const querystring = require('querystring');
const imgPath = require.context('../assets/img/', true);
export default {
	name: 'configurator',
	components: {
		"design-details": require('./design-details.vue').default,
	},
	data() {
		return {
			models: models,
			updateableData: ['model', 'stone', 'color', 'font', 'decoration', 'decoration2', 'size', 'side', 'bottom', 'lastname', 'firstnames', 'dob', 'dod'],
			activeDropdown: '',
			model: '',
			size: '',
			stone: '',
			side: '',
			bottom: '',
			color: 0,
			font: 0,
			decoration: 0,
			decoration2: 0,
			activeHelpInfo: false,
			activeSideInfo: false,
			activeBottomInfo: false,
			activeNamesTotalInfo: false,
			activeOtherInfo: false,
			activeCodeInfo: false,
			activeLastnameInfo: false,
			activeSendEmailInfo: false,
			page: 1,
			pageHeaders: ['Hautakiven suunnittelu', 'Tekstit ja koristeet', 'Vainajan tiedot', 'Tilaajan tiedot', 'Tilaus lähetetty'],
			sendEmail: '',
			sendEmailError: false,
			sendToEmails: [],
			emailSent: false,
			lastname: '',
			firstnames: '',
			dob: '',
			dod: '',
			name: '',
			address: '',
			zip: '',
			city: '',
			phone: '',
			email: '',
			emailError: false,
			church: '',
			graveyard: '',
			graveId: '',
			namesTotal: '',
			other: '',
			code: '',
		}
	},
	watch: {
		lastname: function () {
			this.$nextTick(this.setLastnameSize);
		},
		firstnames: function () {
			this.$nextTick(this.setFirstnameSize);
		},
		color: function () {
			this.setNameSizes();
		},
		font: function () {
			this.setNameSizes();
		},
		decoration: function () {
			this.setNameSizes();
		},
		decoration2: function () {
			this.setNameSizes();
		},
		activeHelpInfo: function (active) {
			if(!active) {
				this.setNameSizes();
			}
		}
	},
	methods: {
		setNameSizes: function() {
			this.$nextTick(function() {
				this.setLastnameSize();
				this.setFirstnameSize();
			});
		},
		setLastnameSize: function() {
			var txt = document.getElementsByClassName('lastname');
			var fontSize = this.model <= 15 || this.model == 19 ? (this.models[this.model].font.options[this.font].class == 'display-font-groteski' ? 21.5 : 24) : (this.models[this.model].font.options[this.font].class == 'display-font-groteski' ? 18 : 20);
			if(txt.length > 0) {
				var w = txt[0].parentNode.clientWidth;
				var style = window.getComputedStyle(txt[0], null);
				txt[0].removeAttribute('style');
				// Measure the rendered text, which may be the preview's example text
				var len = txt[0].textContent.trim().length;
				if(len > 8 || ((this.model == 6 || this.model == 9) && len > 6)) {
					txt[0].setAttribute('style', 'font-size:' + Math.round(Math.min(Math.max(1, w / (txt[0].scrollWidth+20) * parseInt(style.getPropertyValue('font-size'), 10)), fontSize) * 100) / 100 + 'px!important;');
				}
			}
		},
		setFirstnameSize: function() {
			var txt = document.getElementsByClassName('firstname');
			if(txt.length > 0) {
				var w = txt[0].parentNode.clientWidth;
				var style = window.getComputedStyle(txt[0], null);
				var fontSize = parseInt(style.getPropertyValue('font-size'), 10) > 12 ? parseInt(style.getPropertyValue('font-size'), 10) : (this.models[this.model].font.options[this.font].class == 'display-font-groteski' ? 10 : 12);
				txt[0].removeAttribute('style');
				if(txt[0].textContent.trim().length > 10) {
					txt[0].setAttribute('style', 'font-size:' + Math.round(Math.min(Math.max(1, w / (txt[0].scrollWidth+20) * parseInt(style.getPropertyValue('font-size'), 10)), fontSize) * 100) / 100 + 'px!important;');
				}
			}
		},
		setModel: function(key) {
			this.activeDropdown = '';
			this.size = this.stone = this.bottom = 0;
			this.side = this.models[key].side.options.length == 2 ? 1 : this.models[key].side.options.length ? 0 : '';
			this.color = this.font = this.decoration = this.decoration2 = 0;
			this.model = key;
			document.getElementById("select-model").scrollIntoView();
			this.setNameSizes();
		},
		showNext: function() {
			var show = false;

			if(this.page == 1 && this.model !== '' && this.size !== '' && this.stone !== '' && this.bottom !== '') {
				show = true;
			} else if(this.page == 2 && this.color !== '' && this.font !== '' && this.decoration !== '') {
				show = true;
			} else if(this.page == 3 && this.firstnames !== '' && this.lastname !== '' && this.dob !== '' && this.dod !== '') {
				show = true;
			}

			return show;
		},
		nextPage: function() {
			this.page++;
			this.scrollTop();
			this.setNameSizes();
		},
		prevPage: function() {
			this.page--;
			this.scrollTop();
			this.setNameSizes();
		},
		addEmail: function() {
			if(this.testEmail(this.sendEmail)) {
				this.sendEmailError = false;
				this.sendToEmails.push(this.sendEmail);
				this.sendEmail = '';
			} else {
				this.sendEmailError = true;
			}
		},
		testEmail: function(email) {
			var valid = false
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(re.test(String(email).toLowerCase())) {
				valid = true;
			}
			return valid;
		},
		removeEmail: function(i) {
			this.sendToEmails.splice(i, 1);
		},
		sendEmails: function() {
			if(this.sendToEmails.length) {
				var payload = {
					action: 'configurator_send_emails',
					nonce: window.configurator.nonce,
					url: this.createReturnUrl(),
					'emails[]': this.sendToEmails
				};
				var _this = this;
				this.axios.post(window.configurator.ajaxurl, querystring.stringify(payload))
					.then(function (response) {
						_this.sendToEmails = [];
						_this.emailSent = true;
					}).catch(function (error) {
						alert(_this.$t('Tallennus ei onnistunut. Yritä uudelleen.'));
					});
			} else {
				this.sendEmailError = true;
			}
		},
		createReturnUrl: function() {
			var obj = {};
			var dataKeys = this.updateableData;
			for(var index in dataKeys) {
				var key = dataKeys[index];
				obj[key] = this.$data[key];
			}
			var returnUrl = window.location.origin + window.location.pathname + '?' + querystring.stringify(obj);
			return returnUrl;
		},
		openHelp: function() {
			this.activeHelpInfo = true;
			this.$nextTick(function() {
				this.$el.scrollIntoView();
			});
		},
		goToModel: function() {
			this.page = 1;
			this.activeDropdown = 'model';
			this.scrollTop();
		},
		isUpdateableData: function(v) {
			var valid = false;
			var array = this.updateableData;
			for(var key in array) {
				if(v == array[key]) {
					valid = true;
					break;
				}
			}
			return valid;
		},
		imgUrl: function(img) {
			return imgPath(img);
		},
		saveDisabled: function() {
			var b = false;
			var fields = ['model', 'stone', 'color', 'font', 'decoration', 'size', 'lastname', 'firstnames', 'dob', 'dod', 'name', 'address', 'zip', 'city', 'phone', 'email', 'church', 'graveyard', 'graveId'];
			for(var i in fields) {
				if(this.$data[fields[i]] === '') {
					b = true;
					break;
				}
			}
			if(!b && (
				(this.models.length <= this.model || this.model < 0) ||
				(this.models[this.model].size.options.length <= this.size || this.size < 0) ||
				(this.models[this.model].stone.options.length <= this.stone || this.stone < 0) ||
				(this.models[this.model].side.options.length && (this.models[this.model].side.options.length <= this.side || this.side < 0)) ||
				(this.models[this.model].bottom.options.length <= this.bottom || this.bottom < 0) ||
				(this.models[this.model].color.options.length <= this.color || this.color < 0) ||
				(this.models[this.model].font.options.length <= this.font || this.font < 0) ||
				(this.models[this.model].decoration.options.length <= this.decoration || this.decoration < 0) ||
				(this.models[this.model].decoration2 && (this.models[this.model].decoration2.options.length <= this.decoration2 || this.decoration2 < 0))
			)) {
				b = true;
			}
			return b;
		},
		order: function() {
			if(!this.saveDisabled()) {
				var payload = {
					action: 'configurator_order',
					nonce: window.configurator.nonce,
					url: this.createReturnUrl(),
					model: this.models[this.model].name,
					size: this.models[this.model].size.options[this.size].name,
					stone: this.models[this.model].stone.options[this.stone].name,
					side: this.models[this.model].side.options.length ? this.models[this.model].side.options[this.side].name : '',
					bottom: this.models[this.model].bottom.options[this.bottom].name,
					color: this.models[this.model].color.options[this.color].name,
					font: this.models[this.model].font.options[this.font].name,
					decoration: this.models[this.model].decoration.options[this.decoration].name,
					decoration2: this.models[this.model].decoration2 ? this.models[this.model].decoration2.options[this.decoration2].name : '',
					lastname: this.lastname,
					firstnames: this.firstnames,
					dob: this.dob,
					dod: this.dod,
					name: this.name,
					address: this.address,
					zip: this.zip,
					city: this.city,
					phone: this.phone,
					email: this.email,
					church: this.church,
					graveyard: this.graveyard,
					graveId: this.graveId,
					namesTotal: this.namesTotal,
					other: this.other,
					code: this.code
				};
				var _this = this;
				this.axios.post(window.configurator.ajaxurl, querystring.stringify(payload))
					.then(function (response) {
						_this.page = 5;
					}).catch(function (error) {
						alert(_this.$t('Tilaaminen ei onnistunut. Yritä uudelleen.'));
					});
			}
		},
		restart: function() {
			window.location.reload();
		},
		scrollTop: function() {
			document.getElementById("conf-title").scrollIntoView();
		},
		calcPrice: function() {
			var p = 0;
			if(this.model !== '') {
				p = this.models[this.model].size.options[this.size].price;
				if(this.side !== '' && this.models[this.model].side.options.length && this.models[this.model].side.options[this.side].price === true) {
					p += this.models[this.model].size.options[this.size].price_side;
				}
				if(this.bottom !== '' && this.models[this.model].bottom.options[this.bottom].price === true) {
					p += this.models[this.model].size.options[this.size].price_bottom;
				}
				var colorType = this.models[this.model].color.options[this.color].type;
				if(colorType !== '') {
					var field = 'price_'+colorType;
					p += this.models[this.model].decoration.options[this.decoration][field];
					if(this.models[this.model].hasOwnProperty('decoration2') && this.models[this.model].decoration2.options[this.decoration2].hasOwnProperty(field)) {
						p += this.models[this.model].decoration2.options[this.decoration2][field];
					}
					if((this.model == 1 || this.model == 5 || this.model == 11 || this.model == 12) && this.models[this.model].font.options[this.font].hasOwnProperty(field)) {
						p += this.lastname.length * this.models[this.model].font.options[this.font][field];
					} else if(this.models[this.model].font.options[this.font].hasOwnProperty(field)) {
						p += this.models[this.model].font.options[this.font][field];
					}
					field = 'lantern_'+colorType;
					if(this.models[this.model].decoration.options[this.decoration].hasOwnProperty(field)) {
						p += this.models[this.model].decoration.options[this.decoration][field];
					}
				}
			}
			return p;
		}
	},
	mounted(){
		if (window.configurator && window.configurator.stone_options) {
			var wpStones = window.configurator.stone_options;
			for (var i = 0; i < this.models.length; i++) {
				var modelName = this.models[i].name;
				if (wpStones[modelName] && Array.isArray(wpStones[modelName])) {
					var filtered = this.models[i].stone.options.filter(function(opt) {
						return wpStones[modelName].indexOf(opt.key) !== -1 || wpStones[modelName].indexOf(opt.name) !== -1;
					});
					if (filtered.length > 0) {
						this.models[i].stone.options = filtered;
					}
				}
			}
		}
		var query = this.$route.query;
		if(query.hasOwnProperty('model')) {
			if(query['model'] >= 0 && query['model'] < this.models.length) {
				this.model = query['model'];
				this.size = this.stone = this.bottom = 0;
				this.side = this.models[query['model']].side.options.length == 2 ? 1 : this.models[query['model']].side.options.length ? 0 : '';
				delete query['model'];
			}
		}
		for(var q in query) {
			if(this.$data.hasOwnProperty(q) && this.isUpdateableData(q)) {
				var val = String(query[q]);
				if (q == 'firstnames' || q == 'lastname' || q == 'dob' || q == 'dod') {
					this.$data[q] = val;
				} else {
					if(this.model !== '' && this.models[this.model].hasOwnProperty(q) && val >= 0 && val < this.models[this.model][q]['options'].length) {
						this.$data[q] = val;
					}
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
